import React,
{
    useContext,
    useEffect,
    useState,
} from 'react';
import {
    Card,
    CardActionArea,
    CardContent,
    CardHeader,
    Collapse,
    Paper,
    CardActions,
    IconButton,
    Typography,
    Grid,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Snackbar,
} from '@material-ui/core';
import {
    Visibility,
    VisibilityOff,
    Email,
    NotificationsActive,
    DeleteForever,
    RestoreFromTrash
} from "@material-ui/icons";
import {makeStyles} from "@material-ui/styles";
import Firebase from "firebase/app";
import MuiAlert from "@material-ui/lab/Alert";
import {SnackBarContext} from '../Common/Context/SnackBarContext';

const NotificationElement = (props: any) => {
    let {notification, full, onSelect, updateReadStatus, updateDeletionStatus} = props;
    const [expanded, setExpanded] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const classes = useStyle();
    const statusStyle = notification.READ === 'Y' && full !== true ? classes.read : classes.unread;
    const snackbarContext = useContext(SnackBarContext);

    useEffect(() => {
        // console.log(notification, 'timeago')
    }, [])

    const toggleReadStatus = async () => {
        let read = notification.READ === 'Y' ? 'N' : 'Y';

        updateReadStatus(read)

        const firebase_token = await Firebase.auth().currentUser.getIdToken();
        try {
            let response = await fetch(`https://idverify.manhattan.edu/apiv2/api/messagebox/SetMessageStatus/${notification.SURROGATE_ID}`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${firebase_token}`
                    },
                    body: JSON.stringify({read})
                })
            let json = await response.json()

            if (!json)
                updateReadStatus(read === 'Y' ? 'N' : 'Y')

        } catch (error) {
            // console.log(error)
            updateReadStatus(read === 'Y' ? 'N' : 'Y')
        }
    }

    const toggleDeleteStatus = async () => {
        let deleted = notification.DELETED === 'Y' ? 'N' : 'Y';

        updateDeletionStatus(deleted)

        const firebase_token = await Firebase.auth().currentUser.getIdToken();
        try {
            let response = await fetch(`https://idverify.manhattan.edu/apiv2/api/messagebox/SetMessageStatus/${notification.SURROGATE_ID}`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${firebase_token}`
                    },
                    body: JSON.stringify({deleted})
                })
            let json = await response.json()

            if (!json) {
                updateDeletionStatus(deleted === 'Y' ? 'N' : 'Y')
                return 'error';
            }

        } catch (error) {
            // console.log(error)
            updateDeletionStatus(deleted === 'Y' ? 'N' : 'Y')
            return error;

        }
    }


    const date = new Date(notification.SENT_DATE);
    const dateString = notification.timeago ?? `${date.toDateString()} ${date.toLocaleTimeString()}`
    return (
        <Card
            className={classes.cardContainer + ' ' + statusStyle}
            variant={'outlined'}
        >
            <CardActionArea onClick={onSelect}>
            <CardHeader
                className={classes.header}
                avatar={notification.COMMUNICATION_CHANNEL == 'EMAIL' ? <Email className={classes.headerIcon} /> : <NotificationsActive className={classes.headerIcon} />}
                title={
                    <Grid
                        container
                        justify={'space-between'}
                    >
                        <Grid item xs={12}>
                            <Grid
                                container
                                justify={'space-between'}
                            >
                                <Grid item>
                                    <Typography
                                        className={classes.headerTime}
                                    >{ dateString }</Typography>
                                </Grid>
                                {notification.READ === 'Y' &&
                                <Grid item>
                                    <Grid
                                        container
                                        alignItems={'center'}
                                    >
                                        <Grid item>
                                            <Visibility className={classes.seenIcon}/>
                                        </Grid>
                                        <Grid item>
                                            <Typography className={classes.seenText}>read</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>}
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography className={classes.headerFromText}>{notification.FROMSENDER}</Typography>
                        </Grid>

                    </Grid>
                }
            />
            <CardContent className={classes.content}>
                <Typography className={classes.headerTitle}>{notification.HEADLINE}</Typography>
                {full ?
                    (() => (<div
                        id={'htmlContent'}
                        className={classes.htmlContent}
                        dangerouslySetInnerHTML={markup(notification.BODYTEXT)} />))()
                    :
                    <Typography className={classes.contentText}>
                        {notification.BODYTEXT}
                    </Typography>
                }
            </CardContent>
            </CardActionArea>

            {full && <CardActions>
                <Grid
                    container
                    >
                    {notification.DELETED !== 'Y' &&
                        <Grid
                            item>
                            <IconButton onClick={ () => {
                                if (window.webkit && window.webkit.messageHandlers.selection) {
                                    window.webkit.messageHandlers.selectionPrepare.postMessage({body: true})
                                    window.webkit.messageHandlers.selection.postMessage({body: true})
                                }
                                toggleReadStatus()
                            }}>
                                {notification.READ === 'Y' ? <VisibilityOff/> : <Visibility/>}
                            </IconButton>
                        </Grid>
                    }
                    {notification.DESTINATION != null  &&
                    <Grid
                        item>
                        <Button onClick={() => {
                            const url = notification.destination;
                            //@ts-ignore
                            if (window.webkit) {
                                //@ts-ignore
                                window.webkit.messageHandlers.url.postMessage(
                                    {
                                        url,
                                        refresh: false
                                    }
                                )
                            } else {
                                window.open(url)

                            }
                        }}>
                            <Typography>{notification.DESTINATIONLABEL}</Typography>
                        </Button>
                    </Grid>}
                    <Grid
                        item>
                        <IconButton onClick={() => notification.DELETED === 'Y' ? toggleDeleteStatus().then((resp) => {
                            snackbarContext.setSnackBarInfo({
                                status: true,
                                type: resp === undefined ? 'success' : 'error',
                                message: resp === undefined ? 'Success' : resp.error
                            });

                            if (window.webkit && window.webkit.messageHandlers.feedback) {
                                window.webkit.messageHandlers.feedbackPrepare.postMessage({body: true})
                                window.webkit.messageHandlers.feedback.postMessage({type: resp === undefined ? 'Success' : 'Error'})
                            }
                        }) : setOpenAlert(true)}>
                            {notification.DELETED === 'Y' ? <RestoreFromTrash /> : <DeleteForever />}
                        </IconButton>
                    </Grid>

                </Grid>
            </CardActions>
            }
            <DeleteMessageAlert
                open={openAlert}
                item={notification.HEADLINE}
                completion={(confirmed: boolean) => {
                    setOpenAlert(false);
                    if (confirmed) {
                        toggleDeleteStatus()
                            .then((resp) => {
                                snackbarContext.setSnackBarInfo({
                                    status: true,
                                    type: resp === undefined ? 'success' : 'error',
                                    message: resp === undefined ? 'Success' : resp.error
                                });

                                if (window.webkit && window.webkit.messageHandlers.feedback) {
                                    window.webkit.messageHandlers.feedbackPrepare.postMessage({body: true})
                                    window.webkit.messageHandlers.feedback.postMessage({type: resp === undefined ? 'Success' : 'Error'})
                                }
                            });
                    }

                }}
                />
        </Card>
    );
}

const markup = (text:string) => {
    return {__html: text }
};

const DeleteMessageAlert = (props:any) => {
    const {
        open,
        item,
        completion
    } = props;

    const classes = useStyle();

    useEffect(() => {
        if (open && window.webkit && window.webkit.messageHandlers.feedback) {
            window.webkit.messageHandlers.feedbackPrepare.postMessage({body: true})
            window.webkit.messageHandlers.feedback.postMessage({type: 'Warning'})
        }
    }, [open]);

    return(
        <Dialog
            open={open}
            onClose={() => completion(false)}
        >
            <DialogTitle>
                <div dangerouslySetInnerHTML={markup(`Do you want to delete this notification?`)}/>


            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    This action will move <b className={classes.Emphasis}  dangerouslySetInnerHTML={markup(item)}/> to the trash. Are you sure?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    variant={'outlined'}
                    color={'secondary'}
                    onClick={() => completion(false)}
                >
                    Cancel
                </Button>
                <Button
                    onClick={() => completion(true)}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    )
};

const useStyle = makeStyles({
    cardContainer: {
        overflow: 'hidden',
        padding: 8,
    },
    header: {
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 8,
        paddingBottom: 4,
    },
    headerIcon: {
        color: '#046A38',
    },
    headerTitle: {
        fontSize: 14,
        fontWeight: 'bold',
        color: '#046A38',
        lineClamp: 2,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        paddingLeft: 8,
        paddingRight: 8,
    },
    headerTime: {
        fontSize: 12,
        color: 'rgba(0, 0, 0, 0.54)',
    },
    headerFromText: {
        fontSize: 12,
        fontWeight: 'bold'
    },
    content: {
        padding: '0 !important',

    },
    contentText: {
        fontSize: 12,
        padding: 8,
    },
    read: {
        opacity: 0.6,
    },
    unread: {
        opacity: 1.0
    },
    htmlContent: {
        padding: 8
    },
    Emphasis: {
        color: '#046A38'
    },
    seenIcon: {
        height: 12,
        color: '#A51890'
    },
    seenText: {
        fontSize: 12,
        color: '#A51890'
    }
})

export default NotificationElement;